import './style.scss';

import React from 'react';
import Modal from 'react-modal';

const OVERLAY_CLASS_NAME = 'modal-overlay';

function ModalContainer(props) {
  const className =
    'modal-content modal-content--flush' +
    (props.inverse ? ' modal-content--inverse' : '') +
    (props.className ? ` ${props.className}` : '');

  const canClose =
    typeof props.canClose === 'undefined' ? true : props.canClose;

  return (
    <Modal
      overlayClassName={OVERLAY_CLASS_NAME}
      isOpen={props.isOpen}
      className={className}
      onRequestClose={props.handleClose}
      shouldCloseOnOverlayClick={canClose}
      onAfterOpen={props.handleAfterOpen}
      contentLabel={props.contentLabel || ''}
      ariaHideApp={false}
    >
      {canClose && (
        <div className="modal__close" onClick={props.handleClose}>
          ✕
        </div>
      )}
      {props.children}
    </Modal>
  );
}

export default ModalContainer;
export { OVERLAY_CLASS_NAME };
